import React, { useEffect } from 'react';

import './CreativeRequest.scss';

import CreativeRequest from './CreativeRequest';
import { useGetSavedRequestApi } from './api';

import { RATIO, FORMAT } from './constants';
import { useCreativeRequestGet } from './contexts';

const getRatioRate = (data, value) => {
  if (!data || !Array.isArray(data)) return 0;
  const selectedLabel = data.find((label) => label.name === `${value} Ratio`);
  return selectedLabel ? selectedLabel.performance_percent : 0;
};

const getFormatRate = (data, value) => {
  if (!data || !Array.isArray(data)) return 0;
  const selectedLabel = data.find((label) => label.name === value);
  return selectedLabel ? selectedLabel.performance_percent : 0;
};

const Wrapper = ({
  filteredData = [],
  CreativeRequestPortal,
  requestOpen,
  setRequestOpen,
}) => {
  const { currentRequest } = useCreativeRequestGet();
  const open = requestOpen;
  const getSavedRequest = useGetSavedRequestApi();

  useEffect(() => {
    getSavedRequest.get.request();
  }, []);

  const selectedRatio = currentRequest[RATIO];
  const selectedFormat = currentRequest[FORMAT];

  const ratioRate = filteredData
    ? getRatioRate(filteredData, selectedRatio)
    : 0;
  const formatRate = filteredData
    ? getFormatRate(filteredData, selectedFormat)
    : 0;

  return (
    <div className={`request-wrapper${open ? ' open' : ''}`}>
      <CreativeRequestPortal.Portal>
        <CreativeRequest
          open={open}
          ratioRate={ratioRate}
          formatRate={formatRate}
          getSavedRequest={getSavedRequest}
          setRequestOpen={setRequestOpen}
        />
      </CreativeRequestPortal.Portal>
    </div>
  );
};

export default Wrapper;
